import {useEffect, useState} from "react";
import "./ButtonSelect.scss";

export default function ButtonSelect({title, icon=null, isSelected=false, onClick=()=>{}}){
    const [isMouseDown, setIsMouseDown] = useState(false);

    return (
        <button className={"btnSelect "+((isMouseDown || isSelected) ? 'active' : '')}
                onClick={onClick}
                onMouseDown={()=> setIsMouseDown(!isMouseDown)}
                onMouseUp={() => setIsMouseDown(false)}>
            {icon != null ? icon : ''}{title}</button>
    )
}